<template>
  <div class="filters-source">
    <div class="filters-source__title">
      {{ sourceObj.title[$i18n.locale] || sourceObj.title.default }}
    </div>
    <ui-radio
      class="filters-source__radio"
      :id="`source-all`"
      :key="`source-all`"
      v-model="model"
      value="all"
      v-if="sourceObj.sources.length > 1"
    >
      <span class="filters-source__radio__label">
        <span class="filters-source__radio__label__name">
          {{ sourceObj.label[$i18n.locale] || sourceObj.label.default }}
        </span>
        <span v-if="isIntentionView" class="filters-source__radio__label__count">
          {{ numberFormat({ number: sourceObj.total_value, style: 'currency', currency: 'USD' }) }}
        </span>
        <span class="filters-source__radio__label__count" v-else>
          {{ sourceObj.name[$i18n.locale] || sourceObj.name.default }}
        </span>
      </span>
    </ui-radio>
    <ui-radio
      class="filters-source__radio"
      :id="`source-${s.key}`"
      v-for="s in sourceObjOrdered"
      :key="s.key"
      v-model="model"
      :value="s.key"
    >
      <span class="filters-source__radio__label">
        <span class="filters-source__radio__label__name">
          {{ s.label[$i18n.locale] || s.label.default }}
        </span>
        <span v-if="isIntentionView" class="filters-source__radio__label__count">
          {{ numberFormat({ number: s.total_value, style: 'currency', currency: 'USD' }) }}
        </span>
        <span v-else class="filters-source__radio__label__count">
          {{ s.name[$i18n.locale] || s.name.default }}
        </span>
      </span>
    </ui-radio>
  </div>
</template>

<script>
import UiRadio from '@/components/UI/Radio.vue'
import { numberFormat, clone } from '@/utils/formatters.util'

export default {
  name: 'FilterSource',
  components: {
    UiRadio,
  },
  props: {
    sourceObj: {
      type: Object,
      required: true,
    },
    currentSource: {
      type: String,
      required: true,
    },
    isIntentionView: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      numberFormat,
    }
  },
  computed: {
    model: {
      get() {
        return this.currentSource
      },
      set(value) {
        this.$emit('update', value)
      },
    },
    sourceObjOrdered() {
      const sources = clone(this.sourceObj.sources)
      return sources.sort((a, b) => parseFloat(a.total_value) - parseFloat(b.total_value)).reverse()
    },
  },
}
</script>

<style lang="scss" scoped>
.filters-source {
  &__title {
    @include sub-title;
  }

  &__radio {
    margin-bottom: 10px;
    width: 100%;

    &:last-child {
      margin-bottom: 0;
    }

    &__label {
      display: flex;
      justify-content: space-between;

      &__name {
        text-transform: capitalize;
      }

      &__count {
        text-align: right;
        font-weight: bold;
      }
    }
  }
}
</style>
